import Image from 'global/Image';
import If from 'global/ErrorHandlers/If';

import { PAYWALL_IMAGE_URL as IMAGE_URL } from '../../constants';

import {
  ButtonOffer,
  ButtonTextContainer,
  ButtonTitle,
  ButtonDescription,
} from '../styled';

interface IButtonProps {
  title: string;
  description: string;
  iconUrl: string;
  isActive?: boolean;
  onClick: () => void;
}

const ButtonOffering = ({
  title,
  description,
  iconUrl,
  isActive = false,
  onClick,
}: IButtonProps) => {
  const suffixName = isActive ? 'active' : 'right';
  return (
    <ButtonOffer onClick={onClick} isActive={isActive}>
      <Image src={iconUrl} className="icon" />
      <ButtonTextContainer>
        <ButtonTitle>{title}</ButtonTitle>
        <ButtonDescription>{description}</ButtonDescription>
      </ButtonTextContainer>
      <Image src={`${IMAGE_URL}/offering-chevron-${suffixName}.svg`} />

      <If condition={isActive}>
        <Image
          src={`${IMAGE_URL}/offering-star-left.svg`}
          className="star-left"
        />
        <Image
          src={`${IMAGE_URL}/offering-star-right.svg`}
          className="star-right"
        />
      </If>
    </ButtonOffer>
  );
};

export default ButtonOffering;
